import {useRef, useEffect} from 'react';

export const useScrollToBottom = (length) => {
    const containerRef = useRef(null);

    useEffect(()=>{
        containerRef?.current.scrollTo({top: containerRef.current.scrollHeight, behavior:'smooth'});
    }, [length]);

    return containerRef;

}